/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorPlanCreateDto } from '../../models/floor-plan-create-dto';
import { FloorPlanDto } from '../../models/floor-plan-dto';

export interface FloorPlanAdminControllerCreateV1$Params {
      body: FloorPlanCreateDto
}

export function floorPlanAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: FloorPlanAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
  const rb = new RequestBuilder(rootUrl, floorPlanAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloorPlanDto>;
    })
  );
}

floorPlanAdminControllerCreateV1.PATH = '/api/v1/floor-plans/admin';
